import React from 'react'

interface ZeroStateCardProps {
  icon?: React.ReactNode
  message?: string
  className?: string
}

const ZeroStateCard: React.FC<ZeroStateCardProps> = ({
  icon = <i className='bi bi-clipboard-check fs-4 text-success' />,
  message = 'Nothing to review!',
  className = '',
}) => {
  return (
    <div className={`d-flex ${className}`}>
      <div
        className={`custom-card d-flex flex-column align-items-center justify-content-center p-4`}
      >
        <div className='d-flex align-items-center justify-content-center mb-3 zerocard-style'>
          {icon}
        </div>
        <p className='text-muted mb-0 fw-medium text-center'>{message}</p>
      </div>
    </div>
  )
}

export default ZeroStateCard
